module.exports = "<notice-list></notice-list>";


//////////////////
// WEBPACK FOOTER
// ./src/component/systemNotice/noticeIndex.html
// module id = 199
// module chunks = 0